import { styled } from '@uhg-abyss/web/tools/styled';

export const hamburgerButton = {
  'abyss-button-root': {
    padding: '0px 0px 0px 0px',
    border: 'none',
    outline: 'none',
    marginBottom: '-4px',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#FBFCFE',
      border: 'none',
      outline: 'none',
    },
    '@media (max-width: 464px)': {
      paddingTop: '12px',
    },
  },
};

export const tabsCategory = {
  color: '$core.color.brand.100',
  lineHeight: '28px',
  fontSize: '1.602rem',
  paddingBottom: '8px',
};

export const tabFlexStyle = {
  'abyss-flex-root': {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    borderColor: '$core.color.neutral.20',
    borderWidth: '0px 0px 1px 0px ',
    borderStyle: 'solid',
  },
};

export const browseFlexStyle = {
  borderStyle: 'solid',
  borderColor: '$core.color.neutral.20',
  borderWidth: '1px 0px 0px 0px ',
  padding: '24px 0px 0px 0px',
  '@media (max-width: 744px)': {
    borderWidth: '0px 0px 0px 0px ',
  },
  '@media (max-width: 464px)': {
    padding: '16px 0px 0px 0px',
  },
  '.abyss-button-root': {
    marginBottom: '-4px !important',
  },
};

export const tabsLayoutStyles = {
  '.abyss-layout-stack': {
    margin: '0px',
  },
  '.abyss-flex-root': {
    paddingLeft: 'calc((100% - 1200px) / 2)',
    paddingRight: 'calc((100% - 1200px) / 2)',
    '@media (max-width: 1248px)': {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
    '@media (max-width: 744px)': {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
};

export const TabsContainer = styled('div', {
  display: 'inline-flex',
  overflow: 'auto',
  scrollbarWidth: 'none',
  scrollBehavior: 'smooth',
  scrollbarColor: 'transparent transparent',
  '.abyss-psx-parcel-c-esCbFz': {
    borderStyle: 'solid',
    borderColor: '$cardBorder',
    borderWidth: '0px 0px 0px 0px ',
  },
  '.abyss-tabs-content-container': {
    borderWidth: '0px 0px 0px 0px',
    padding: '0px',
  },
  '.abyss-tabs-tab-content': {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '20px',
    textAlign: 'center',
    '@media (max-width: 464px)': {
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: '24px',
      textAlign: 'center',
    },
  },
  '.abyss-tabs-tab-active-line': {
    '@media (max-width: 464px)': {
      borderColor: '$core.color.neutral.80',
      borderRadius: '6px 6px 0px 0px',
    },
  },
  '.abyss-tabs-list': {
    padding: '4px',
    textWrap: 'nowrap',
    scrollBehavior: 'smooth',
    scrollbarColor: 'transparent transparent',
    overflowX: 'auto',
    border: 'none',
    div: {
      gap: '16px',
    },
    button: {
      borderBottomWidth: '0px',
      minWidth: 'unset',
      padding: '8px 16px',
      '@media (max-width: 464px)': {
        padding: '10px 12px',
      },
    },
    '@media (max-width: 464px)': {
      display: 'flex',
    },
    '.abyss-psx-parcel-c-jekBZS-kGZVKw-display-row': {
      minWidth: 'fit-content',
    },
    '.abyss-tabs-tab': {
      minHeight: '30px',
      '&.active': {
        backgroundColor: 'white',
      },
    },
  },
});
